import React, { useMemo } from "react";
import { Calendar as CalendarComponent } from "../ui/calendar";
import { Badge } from "../ui/badge";
import { TaskCard } from "../TaskCard";
import { statusIcons } from "../../utils/helpers";

const STATUS_LABELS = { todo: 'To Do', in_progress: 'In Progress', delayed: 'Delayed', completed: 'Completed' };
const STATUSES = ['todo', 'in_progress', 'delayed', 'completed'];

export const KanbanView = ({ tasksByStatus, taskCardProps }) => (
  <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-testid="kanban-view">
    {STATUSES.map(status => (
      <div key={status} className="space-y-3">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-gray-700 flex items-center gap-2">
            {statusIcons[status]} {STATUS_LABELS[status]}
          </h3>
          <Badge variant="outline">{tasksByStatus[status].length}</Badge>
        </div>
        <div className="space-y-3">
          {tasksByStatus[status].map(task => (
            <TaskCard key={task.id} task={task} {...taskCardProps} />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export const ListView = ({ tasks, taskCardProps }) => (
  <div className="space-y-3" data-testid="list-view">
    {tasks.map(task => (
      <TaskCard key={task.id} task={task} {...taskCardProps} />
    ))}
  </div>
);

export const CalendarView = ({ tasks, selectedDate, setSelectedDate, taskCardProps }) => {
  const calendarTasks = useMemo(() => {
    if (!selectedDate) return [];
    return tasks.filter(t => {
      const td = new Date(t.sliding_date || t.planned_date);
      return td.toDateString() === selectedDate.toDateString();
    });
  }, [tasks, selectedDate]);
  return (
    <div className="flex gap-6" data-testid="calendar-view">
      <CalendarComponent mode="single" selected={selectedDate} onSelect={setSelectedDate} className="rounded-md border" />
      <div className="flex-1 space-y-3">
        <h3 className="font-semibold text-gray-700">Tasks for {selectedDate?.toLocaleDateString()}</h3>
        {calendarTasks.map(task => (
          <TaskCard key={task.id} task={task} {...taskCardProps} />
        ))}
      </div>
    </div>
  );
};
